export const getFlags = state => state.featureFlags.flags;